import { ProjectsView } from "fond/types";
import { reduceReducers } from "fond/utils";

interface UpdateFilter {
  type: "UpdateFilter";
  filters: ProjectsView;
}

type Action = UpdateFilter;

export function updateFilter(filter: ProjectsView): Action {
  return { type: "UpdateFilter", filters: filter };
}

const initialState: Pick<UpdateFilter, "filters"> = {
  filters: "workspace",
};

export const reducer = reduceReducers(function reducer(state = initialState, action: Action) {
  switch (action.type) {
    case "UpdateFilter":
      return {
        ...state,
        filters: action.filters,
      };
    default:
      return state;
  }
});
